import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="m1 11 9 7m0 0 9-7m-9 7V0" stroke="#919499" />
  </svg>
);
const Memo = memo(SvgArrow);
export default Memo;
